function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M15,16.5 C15,16.776 14.776,17 14.5,17 L9.5,17 C9.224,17 9,16.776 9,16.5 L9,15.5 C9,15.224 9.224,15 9.5,15 L10.5,15 C10.776,15 11,14.776 11,14.5 L11,11.5 C11,11.224 10.776,11 10.5,11 L9.5,11 C9.224,11 9,10.776 9,10.5 L9,9.5 C9,9.224 9.224,9 9.5,9 L12.5,9 C12.776,9 13,9.224 13,9.5 L13,14.5 C13,14.776 13.224,15 13.5,15 L14.5,15 C14.776,15 15,15.224 15,15.5 L15,16.5 Z M11,6.5 C11,6.224 11.224,6 11.5,6 L12.5,6 C12.776,6 13,6.224 13,6.5 L13,7.5 C13,7.776 12.776,8 12.5,8 L11.5,8 C11.224,8 11,7.776 11,7.5 L11,6.5 Z M12,2 C6.477,2 2,6.477 2,12 C2,17.523 6.477,22 12,22 C17.523,22 22,17.523 22,12 C22,6.477 17.523,2 12,2 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "2 2 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/information.f27b4237.svg";
export { SvgComponent as ReactComponent };